import React from 'react';
import Text from '../text/Text';

interface ErrorsMessageProps {
  errors?: Errors;
  name: string;
  getTranslation?: (message: string) => string;
}

type Status =
  | 'primary'
  | 'secondary'
  | 'danger'
  | 'warning'
  | 'success'
  | 'info'
  | 'dark'
  | 'default';

export type Errors =
  | {
      [key: string]: [
        {
          [key: string]: {
            [message: string]: string;
          };
        },
      ];
    }
  | {
      [key: string]: {
        [message: string]: string;
      };
    }
  | string;

export const getStatus = (errors?: Errors, name?: string, status?: Status) =>
  handleObjectData(name, errors) ||
  typeof errors === 'string' ||
  handleArrayData(name, errors)
    ? 'danger'
    : status;

export const handleObjectData = (name: string, errors?: Errors): string => {
  const names = name.split('.');

  if (names.length) {
    return errors?.[names[names.length - 1]]?.message;
  }
};

export const handleArrayData = (name: string, errors?: Errors): string => {
  const names = name.split('.');

  if (names.length >= 3) {
    return errors?.[names[names.length - 3]]?.[
      parseInt(names[names.length - 2])
    ]?.[names[names.length - 1]]?.message;
  }
};

function ErrorMessage({ errors, name, getTranslation }: ErrorsMessageProps) {
  if (errors && typeof errors === 'string') {
    return (
      <Text size="sm" color="danger">
        {getTranslation ? getTranslation(errors) : errors}
      </Text>
    );
  }

  if (errors && handleObjectData(name, errors)) {
    const message: string = handleObjectData(name, errors);
    return (
      <Text size="sm" color="danger">
        {getTranslation ? getTranslation(message) : message}
      </Text>
    );
  }

  if (errors) {
    const message: string = handleArrayData(name, errors);
    if (message) {
      return (
        <Text size="sm" color="danger">
          {getTranslation ? getTranslation(message) : message}
        </Text>
      );
    }
  }
}

export default ErrorMessage;
